export class Animator {

    private static readonly MILLIS_TO_WAIT = 800;

    private static openRequests = 0;

    private static node: HTMLElement | null = document.getElementById('loaderAnim');

    static addRequest() {
        if (!Animator.node) {
            Animator.node = document.getElementById('loaderAnim');
        }

        if (!Animator.node) {
            return;
        }

        Animator.openRequests++;

        window.setTimeout(
            () => {
                if (Animator.openRequests !== 0 && Animator.node) {
                    Animator.node.style.display = 'block';
                }
            },
            Animator.MILLIS_TO_WAIT
        );
    }

    static resolveRequest() {
        if (!Animator.node) {
            return;
        }

        Animator.openRequests--;
        if (Animator.openRequests < 0) {
            Animator.openRequests = 0;
        }

        if (Animator.openRequests === 0) {
            Animator.node.style.display = 'none';
        }
    }

    static reset() {
        Animator.openRequests = 0;
    }

}
